import { Box, Spinner, Text } from 'grommet';
import React from 'react';

export interface LoadingProps {
  size?: 'xsmall' | 'small' | 'medium' | 'large' | 'xlarge';
  text?: string;
}

const Loading: React.FC<LoadingProps> = ({ size = 'large', text = 'Loading...' }): JSX.Element => {
  return (
    <Box
      align="center"
      justify="center"
      direction="row"
      gap="small"
      pad="small"
      fill
    >
      <Spinner size={size} />
      <Text size={size}>{text}</Text>
    </Box>
  );
};

Loading.displayName = 'Loading';

export default Loading;
